import ProductVideoDetail from './ProductVideoDetail';

export default ProductVideoDetail;


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVideosTab/ProductVideos/ProductVideoDetail/index.tsx